<template>
    <div>
        <template v-if="crud_designation === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Designations</h1>
                <router-link to="/addEditDesinationsMapping" class="btn btn-primary float-right active ml-1" v-if="crud_designations_mapping === true"> Add Designations Mapping</router-link>
                <router-link to="/addDesignation" class="btn btn-primary float-right active"> Add Designation</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" autocomplete="off" />
                </div>
            </div>
            <table id="designationTable" class="table">
                <thead>
                    <tr>
                        <th style="display: none;"></th>
                        <th>Designation</th>
                        <th>Department</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-if="crud_designation === null"><preLoader></preLoader></template>
        <template v-if="crud_designation === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                crud_designation : null,
                crud_designations_mapping : null,
            };
        },
        methods: {
            getDesignationData(){
                var designationTable = $('#designationTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/listDesignations",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'department'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editDesignation/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"><i class="fas fa-pencil-alt"></i></a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="action edit"> <i class="fas fa-trash-alt"></i> </a>';
                        }}
                    ],
                    drawCallback: function(settings){
                        $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    designationTable.search(this.value).draw();
                });
            },
          softDelete(designationId) {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to delete this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.value) {
                axios.post("/api/designationSoftDelete", {DesignationId: designationId})
                    .then(res => {
                      if(res.status == 200){
                        this.showToastBox('success','Designation deleted successfully!');
                        this.$router.go(this.$router.currentRoute);
                        this.$Progress.finish();
                      }else{
                        this.$Progress.fail();
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                        })
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.$Progress.fail();
                      this.showAlertBox('error','couldnt find requested data');
                    });
              }
            })
          }
        },
        mounted() {
          var gThat = this;
            this.$Progress.start();
            this.can('crud_designation|crud_designations_mapping').then(result=>{
                this.crud_designation = result.crud_designation;
                this.crud_designations_mapping = result.crud_designations_mapping;
            }).then(result=>{
                if(this.crud_designation === true){
                    this.getDesignationData();                    
                }
            })
          window.softDelete = function(designationId){
            gThat.softDelete(designationId);
          }
        }       
    }
</script>
